// import React from "react";
import { FiSend } from "react-icons/fi";
import React, { useState, useEffect, useContext } from 'react';
import { getSellerRevenueSummary } from '../../../../api/order/orderApi';
import { Container, Row, Col, Card, CardBody, Table } from 'reactstrap';
import { getOrderSummaryByBoatOwner } from '../../../../api/order/orderApi';
import { getMontlyRevenue } from '../../../../api/order/orderApi';
import { getOrdersByBoatOwner } from '../../../../api/order/orderApi';
import axios from 'axios';
import {
  faShoppingCart,
  faRefresh,
  faRocket,
  faCreditCard,
  faSpaghettiMonsterFlying,
  faPiggyBank,
  faCodeCompare,
  faThermometerAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import DataTable from 'react-data-table-component';
import manChecking from '../../../../assets/images/man-checking.png';
import { motion } from 'framer-motion';
import { AuthContext } from '../../../../pages/ExtraPages/AuthProvider';
// Register the necessary Chart.js components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const NeumorphismButton = () => {
  const buttonStyle = {
    padding: '6px 16px',
    border: 'none',
    borderRadius: '50px',
    backgroundColor: '#E6F0FA', // Light blue
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#003366', // Dark blue
    transition: 'all 0.3s ease',
  };

  const hoverStyle = {
    backgroundColor: '#003366', // Dark blue
    color: '#E6F0FA', // Light blue for hover effect
  };

  const [isHovered, setHovered] = React.useState(false);

  return (
    <button
      style={isHovered ? { ...buttonStyle, ...hoverStyle } : buttonStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FiSend />
      <span>Track</span>
    </button>
  );
};

const Overview = () => {
  const [revenueData2, setRevenueData] = useState([]);
  const [isHovered, setHovered] = useState(false);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [ordersSummary, setOrdersSummary] = useState({});
  const [comaparePercentage, setComparePercentage] = useState(0);
  const [monthlyRevenue, setMonthlyRevenue] = useState({
    labels: [],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });

  const [orders, setOrders] = useState([]);
  const { user } = useContext(AuthContext);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Revenue Line Chart',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Define columns
  const columns = [
    {
      name: 'Date',
      selector: (row) => new Date(row.Order_Date).toISOString().split('T')[0],
      sortable: true,
    },
    {
      name: 'Product',
      selector: (row) => row.Product_Name,
      sortable: true,
    },

    {
      name: 'Product',
      selector: (row) => row.Product_Name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) => row.Status,
    },
    {
      name: 'Quantity',
      selector: (row) => row.quantity,
      sortable: true,
    },
    {
      name: 'Unit Price (kg)',
      selector: (row) => row.Price_per_Kg,
      sortable: true,
    },

    {
      name: 'Total',
      selector: (row) => row.quantity * row.Price_per_Kg,
      sortable: true,
      right: true, // Aligns the content to the right
    },
  ];
  useEffect(() => {
    const fetchRevenueData = async () => {
      if (!user || !user.uid) return;
      const userId = user.uid;
      const year = new Date().getFullYear().toString();
      try {
        const response = await getSellerRevenueSummary(userId);
        if (response?.data?.data) {
          setTotalRevenue(response.data.data.totalRevenue || 0);
        }

        const response1 = await getOrderSummaryByBoatOwner(userId);
        if (response1?.data?.data) setOrdersSummary(response1.data.data || {});

        const response3 = await getMontlyRevenue(userId, year);
        if (response3?.data) setMonthlyRevenue(response3.data);

        const response4 = await getOrdersByBoatOwner(userId);
        if (response4?.data?.data) {
          const ordersData = response4.data.data || [];
          setOrders(ordersData);

          // Compute total for Paid orders using Price_per_Kg * quantity
          const paidOrders = ordersData.filter(
            (o) => o.Status === 'Paid' || o.status === 'Paid'
          );

          const paidTotal = paidOrders.reduce((sum, o) => {
            const qty =
              Number(o.quantity ?? o.Ordered_Quantity ?? o.Ordered_Quantity) ||
              0;
            const price = Number(o.Price_per_Kg) || 0;
            return sum + qty * price;
          }, 0);

          // Set totalRevenue from Paid orders (overrides summary if present)
          setTotalRevenue(paidTotal);
        }
      } catch (error) {
        console.error('Error fetching revenue data:', error);
      }
    };

    fetchRevenueData();
  }, [user]);

  const averageOrderValue = ordersSummary?.totalOrders
    ? (totalRevenue / ordersSummary.totalOrders).toFixed(2)
    : '0.00';

  const ordersCount = ordersSummary?.totalOrders || orders.length || 0;

  const averageUnitPrice = (() => {
    console.log('orders for avg unit price', orders);
    if (!orders || orders.length === 0) return '0.00';
    let totalQty = 0;
    let totalValue = 0;
    for (const o of orders) {
      const qty = Number(o.quantity) || 0;
      const price = Number(o.Price_per_Kg) || 0;
      totalQty += qty;
      totalValue += price * qty;
    }
    if (totalQty === 0) return '0.00';
    return (totalValue / totalQty).toFixed(2);
  })();

  const totalOrdersCount = ordersSummary?.totalOrders || orders.length || 0;

  const totalQuantity = orders.reduce((sum, o) => {
    const q = Number(o.quantity) || 0;
    return sum + q;
  }, 0);

  const totalOrderValue = orders.reduce((sum, o) => {
    const q = Number(o.Ordered_Quantity) || 0;
    const p = Number(o.Price_per_Kg) || 0;
    return sum + q * p;
  }, 0);

  const todayISO = new Date().toISOString().split('T')[0];
  const todaysOrdersCount = orders.filter((o) => {
    if (!o.Created_At) return false;
    const d = new Date(o.Created_At).toISOString().split('T')[0];
    return d === todayISO;
  }).length;

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const thisMonthOrdersCount = orders.filter((o) => {
    if (!o.Created_At) return false;
    const d = new Date(o.Created_At);
    return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
  }).length;

  // Format today's date as "27th August, 2025, Friday"
  const getOrdinal = (n) => {
    const v = n % 100;
    if (v >= 11 && v <= 13) return 'th';
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const _today = new Date();
  const _day = _today.getDate();
  const _monthName = _today.toLocaleString('en-US', { month: 'long' });
  const _year = _today.getFullYear();
  const _weekday = _today.toLocaleString('en-US', { weekday: 'long' });
  const todayDisplay = `${_day}${getOrdinal(
    _day
  )} ${_monthName}, ${_year}, ${_weekday}`;

  const revenueData = [
    { month: 'Jan', revenue: 3000 },
    { month: 'Feb', revenue: 4000 },
    { month: 'Mar', revenue: 3200 },
    { month: 'Apr', revenue: 4500 },
    { month: 'May', revenue: 5000 },
    { month: 'Jun', revenue: 6000 },
  ];

  const ongoingOrders = [
    { id: 1, product: 'Fish', status: 'Processing', quantity: 10 },
    { id: 2, product: 'Shrimp', status: 'Shipped', quantity: 15 },
    { id: 3, product: 'Crab', status: 'Processing', quantity: 8 },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }} // Initial state
      animate={{ opacity: 1, y: 0 }} // Animation when component mounts
      exit={{ opacity: 0, y: -20 }} // Exit animation
      transition={{ duration: 0.5 }} // Transition duration
    >
      <Container
        fluid
        className="mt-4"
      >
        <Row className="g-4">
          {/* Left Section - Revenue & Orders Overview */}
          <Col
            md={12}
            lg={8}
            sm={12}
          >
            <Row
              className="g-4 p-3 margin-right1"
              style={{
                background: 'white',
                borderRadius: '10px',
              }}
            >
              {[
                {
                  title: 'Vs last month',
                  icon: faCodeCompare,
                  value: `${comaparePercentage}%`,
                  bg:
                    comaparePercentage > 0
                      ? 'bg-c-green'
                      : comaparePercentage === 0
                      ? 'bg-c-yellow'
                      : 'bg-c-pink',
                  background: '#8380FF',
                },
                {
                  title: 'Total Orders',
                  icon: faShoppingCart,
                  value: ordersCount,
                  bg: 'bg-c-blue',
                  background: '#00A991',
                },
                {
                  title: 'Average Unit Price (kg)',
                  icon: faPiggyBank,
                  value: `LKR ${averageUnitPrice}`,
                  bg: 'bg-c-blue',
                  background: '#003B8F',
                },
              ].map(({ title, icon, value, bg, background }, index) => (
                <Col
                  sm={12}
                  lg={4}
                  md={12}
                  key={index}
                >
                  <div
                    className={
                      title != 'Average Order Value' ? `border-right1` : ''
                    }
                  >
                    <div>
                      <div
                        className="m-b-20"
                        style={{ color: 'black' }}
                      >
                        <FontAwesomeIcon
                          icon={icon}
                          className="f-left"
                          style={{
                            fontSize: '1.2rem',
                            borderRadius: '40px',
                            background: background,
                            padding: '10px',
                            color: 'white',
                          }}
                        />
                        <div style={{ position: 'relative', left: '20px' }}>
                          <div className="text-black">{title}</div>
                          <div>
                            <h3>{value}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            {/* Monthly Revenue Chart */}
            <Row
              className="g-4 margin-right1"
              style={{ marginTop: '0px' }}
            >
              <div
                style={{
                  backgroundColor: '#fff',
                  padding: '20px',
                  borderRadius: '10px',
                }}
              >
                <h5>Revenue Insights</h5>
                <Line
                  data={monthlyRevenue}
                  options={options}
                />
              </div>
            </Row>
          </Col>

          {/* Right Section - Revenue & Orders Summary */}
          <Col
            lg={4}
            md={12}
            sm={12}
            className="g-4 p-4 margin-zero"
            style={{ background: 'white', borderRadius: '10px' }}
          >
            <h4>Revenue & Orders</h4>
            <hr />
            <span className="text-gray">Your total revenue is</span>
            <h1>LKR {totalRevenue}</h1>
            <span className="text-black">{todayDisplay}</span>
            <hr />
            <span className="text-black">This Month Orders</span>{' '}
            <span className="text-black">
              <b>{thisMonthOrdersCount} orders</b>
            </span>
            <hr />
            <span className="text-black">Today Orders</span>{' '}
            <span className="text-black">
              <b>{todaysOrdersCount} orders</b>
            </span>
            <hr />
            <span className="text-black">Total Quantity (kg)</span>{' '}
            <span className="text-black">
              <b>{totalQuantity}</b>
            </span>
            <hr />
            <span className="text-black">Total Order Value</span>{' '}
            <span className="text-black">
              <b> LKR {totalOrderValue.toFixed(2)}</b>
            </span>
            <img
              src={manChecking}
              style={{ paddingTop: '40px', display: 'block', width: '50%' }}
            />
          </Col>
        </Row>

        {/* Ongoing Orders Table */}
        <Row
          className="g-4"
          style={{ marginTop: '0px' }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              overflowX: 'auto',
            }}
          >
            <h5>Ongoing Orders</h5>
            <DataTable
              columns={columns}
              data={orders}
              pagination
            />
          </div>
        </Row>
      </Container>
    </motion.div>
  );
};

export default Overview;
